import { useCurrentUser } from '@qualio/ui-components';
import { useMemo } from 'react';
import { CurrentUser } from '../types';

export const useMcpEnabled = (): boolean => {
  const user = useCurrentUser() as CurrentUser;

  return useMemo(() => {
    const isCapabilityEnabled = user.capabilities?.mcp === true;
    const hasInstancePermission = (user.company as any)?.mcp_enabled === true;
    return isCapabilityEnabled && hasInstancePermission;
  }, [user]);
};
